module.exports = __webpack_public_path__ + "img/twoBJBlue.9cbcb09a.png";